import { useCallback } from "react";

import {
    NavigateFunction,
    useNavigate as useRouterNavigate,
} from "react-router-dom";

const navigationState = {
    navigating: false,
};

window.addEventListener("beforeunload", () => {
    navigationState.navigating = true;
});

export const useNavigate = () => {
    const navigate = useRouterNavigate();

    const newNavigate: NavigateFunction = useCallback(
        (...args: Parameters<NavigateFunction>) => {
            if (navigationState.navigating) {
                return;
            }

            return navigate(...args);
        },
        [navigate]
    ) as any;

    return newNavigate;
};

export default useNavigate;
